// extracted by mini-css-extract-plugin
export var footer_background = "footer-module--footer_background--odr-O";
export var footer_contactLine = "footer-module--footer_contactLine--Rtkvs";
export var footer_disclaimer = "footer-module--footer_disclaimer--E6-Lo";
export var footer_listItems = "footer-module--footer_listItems--+LIAw";
export var footer_subhead = "footer-module--footer_subhead--HiPG0";